var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsideAntenna01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.52,
    y: 1.32,
    className: "st2",
    width: 0.5,
    height: 13.36
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.93,
    y: 5.01,
    className: "st2",
    width: 11.76,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.89,
    y: 5.39,
    className: "st2",
    width: 9.84,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 6.01,
    className: "st2",
    width: 7.3,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.87,
    y: 3.74,
    className: "st2",
    width: 5.54,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.41,12.18c0,0.12-0.09,0.22-0.23,0.22c-0.13,0-0.21-0.1-0.21-0.22c0-0.13,0.09-0.22,0.22-0.22 C11.33,11.96,11.41,12.06,11.41,12.18z M11.02,14.68v-1.95h0.35v1.95H11.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.96,13.26c0-0.2,0-0.37-0.02-0.53h0.31l0.02,0.32h0.01c0.1-0.18,0.32-0.37,0.64-0.37 c0.27,0,0.69,0.16,0.69,0.83v1.16h-0.36v-1.12c0-0.31-0.12-0.58-0.45-0.58c-0.23,0-0.42,0.16-0.48,0.36 c-0.02,0.04-0.02,0.11-0.02,0.17v1.17h-0.35V13.26z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsideAntenna01);
export default __webpack_public_path__ + "static/media/InsideAntenna-01.8a2dbd31c48f99097ca544b956cd5266.svg";
export { ForwardRef as ReactComponent };